


















import { AppModule } from '@/store/modules/app'
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ContentPrice } from '@/components/common/Content.vue'
import i18n from '@/i18n'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)

@Component({
  name: "shipping-overlay"
})
export default class ShippingOverlay extends ContentPrice {
    get show() {
        return AppModule.showShippingOverlay
    }

    get hidePreviewButton() {
        return AppModule.hidePreviewButton
    }

    get deliveryCountry() {
        if (AppModule.session.deliveryCountry) {
            return i18n.t(AppModule.session.deliveryCountry.toLowerCase())
        }
        return ""
    }

    get shippingCost() {
        if (AppModule.session.shippingCostAmount) {
            return AppModule.session.shippingCostAmount
        }
        return ""
    }

    get shippingCostCurrency() {
        if(AppModule.session.shippingCostCurrency) {
            if(AppModule.session.shippingCostCurrency == "EUR") return "€"
            if(AppModule.session.shippingCostCurrency == "USD") return "$"
            if(AppModule.session.shippingCostCurrency == "GBP") return "£"
            if(AppModule.session.shippingCostCurrency == "CHF") return "SFr. "
            return AppModule.session.shippingCostCurrency
        }
        return ""
    }

    get shippingMessage() {
        let deliveryCountry = ''
        if (AppModule.session.deliveryCountry) {
            deliveryCountry = AppModule.session.deliveryCountry.toLowerCase()
        }
        if (i18n.locale === 'de') {
            if (deliveryCountry === 'de') {
                return i18n.t('shippingMessage').toString() + i18n.t('deliveryCompany').toString()
            } else {
                return i18n.t('shippingMessage').toString() + this.deliveryCountry + ' '
            }
        } else if (i18n.locale === 'fr') {
            if (deliveryCountry === 'fr') {
                return i18n.t('shippingMessage').toString() + i18n.t('deliveryCompany').toString()
            } else {
                return i18n.t('shippingMessage').toString() + ' '
            }
        }
        return i18n.t('shippingMessage').toString()
    }

    onClose() {
        AppModule.SetShowShippingOverlay(false)
    }
}
